import axiosInstance from "@/lib/axios";

export const shopSubscriptionService = {
  getSubscriptions: async (params) => {
    const response = await axiosInstance.get("/api/v1/admin/shop-subscriptions", { params });
    return response.data;
  },

  createManualSubscription: async (data) => {
    const response = await axiosInstance.post("/api/v1/admin/shop-subscriptions", data);
    return response.data;
  },

  updateSubscriptionStatus: async (id, data) => {
    const response = await axiosInstance.put(`/api/v1/admin/shop-subscriptions/${id}/status`, data);
    return response.data;
  }
};
